module.exports = __webpack_public_path__ + "static/media/tvMovie-min.4da497d6.jpg";